// import React, { Component } from "react";
// //import { Redirect } from '@reach/router'
// import { inject } from "mobx-react";
// import { AppStore } from "~/stores/AppStore";
// import { redirect } from "react-router-dom";

// @inject("store")
// export class AzureAuthResult extends Component<{
//   path?: string;
//   store?: AppStore;
// }> {
//   public componentDidMount(): void {
//     //this.props.store.isRedirecting = true;
//   }

//   public render() {
//     redirect("/home");
//     //return <Redirect to='/login' noThrow={true} />
//     return <div>Redirecting...</div>;
//     //return (window.location.href = "/login");
//   }
// }

import { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";

interface Props {}

const AzureAuthResult: FC<Props> = (props) => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/login");
  });

  return null;
};

export { AzureAuthResult };
